// extracted by mini-css-extract-plugin
module.exports = {"topIn":"_category_topIn_1CJxU"};